import React from 'react'
import ConfigPage from '@/pages/ConfigPage'
import Expired from '@/pages/Expired'
import request from '@/assets/js/request'
import {
    connectWebViewJavascriptBridge,
    getParams,
    device,
    urlObjectToStrings
} from '@/assets/js/utils'
// import { initializeEncryption } from '@/assets/js/encryption/aesTools'

class App extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            list: [], // 模板报文数组
            effectStatus: '', // 页面生效状态: 1 待生效, 2 生效中, 3 已失效
            titleData: {}, // 页面标题
            productList: [], // 活动场次产品列表模板,
            timeDiff: null,
            activityId: '',
            businessLine: '',
            source: getParams().source // 页面来源
        }
    }

    // 获得区域地址
    getLocation (callback) {
        return new Promise((resolve, reject) => {
            try {
                window.GomeJSBridge.getLocation((data) => {
                    resolve(data.city.code)
                }, (err) => {
                    reject(err)
                })
            } catch (err) {
                resolve('')
            }
        })
    }

    async getList () {
        // url拼接的?pageId=15422&id=15422,转化为对象,作为接口的传参
        const paramsArr = window.location.pathname.split('/')
        const params = new URLSearchParams(window.location.search)
        const pageId = params.get('pageId') || paramsArr[paramsArr.length - 1]
        const isPreview = params.get('isPreview')
        const areaCode = device.isGomePlus ? await this.getLocation() : ''
        const source = this.state.source
        let productList = []
        const { data = {}, stime } = await request.get('/gateway/v1/config/basePageInfo', {
            params: {
                pageId,
                isPreview,
                source,
                areaCode
            },
            headers: {
                businessLine: source === 'plus' ? '0917' : '2048'
            }
        })
        const { titleData } = data
        const timeDiff = stime - new Date().getTime()
        const activityVenueList = data.list.find(item => item.templateType === 'TPL_ACTIVITY_VENUE_PRODUCT_LIST')
        if (activityVenueList) {
            productList = await request.get('/gateway/v1/activity/getProductList', {
                params: {
                    isPreview,
                    activityId: (titleData && titleData.activityId) || '',
                    businessLine: activityVenueList.sublist[0].businessLine || ''
                }
            })
        }
        this.setState({
            list: data.list || [], // 需要改动
            effectStatus: data.effectStatus + '' || '',
            titleData: titleData || {},
            productList: productList.data || [], // 需要改动
            timeDiff: timeDiff || '', // 服务器时间与本地时间差
            activityId: (titleData && titleData.activityId) || '',
            businessLine: activityVenueList ? activityVenueList.sublist[0].businessLine : ''
        })
        if (!titleData) return
        const { title, isSupportShare, titleBackgroundColor, titleTextColor, pageTrackId } = titleData
        setTimeout(() => {
            this.setTitle(title, titleBackgroundColor, titleTextColor)
            this.setShare(isSupportShare, titleData)
        }, 0)
        // 神策页面埋点
        window.$webTrack('ZXcorepageview', {
            screen_name: pageTrackId,
            title: title || pageTrackId
        })
    }

    // 设置标题
    setTitle (title, titleBackgroundColor, titleTextColor) {
        // const paramsArr = window.location.pathname.split('/')
        // const pageId = getParams().pageId || paramsArr[paramsArr.length - 1]
        if (!title) return
        if (device.isGomePlus) {
            window.GomeJSBridge.setHeadBar(null, null, { title })
            return
        }
        connectWebViewJavascriptBridge(JSBridge => {
            JSBridge.callHandler('gome_title', {
                title,
                titleColor: titleTextColor,
                backgroundColor: titleBackgroundColor,
                borderHidden: true
            })
        })
        document.title = title
    }

    // 设置分享
    setShare (isSupportShare, titleData) {
        if (isSupportShare !== '1') return
        const url = getParams().pageId ? `${window.location.href.split('?')[0]}?pageId=${
            getParams().pageId
        }` : window.location.href.split('?')[0]
        const {
            qRCodePageUrl: webUrl,
            shareContent: shareUrlContent,
            shareIconUrl: shareImageUrl,
            shareTitle,
            shareUrl = url
        } = titleData
        connectWebViewJavascriptBridge(JSBridge => {
            JSBridge.callHandler('gome_share', {
                webUrl,
                shareUrlContent,
                shareImageUrl,
                shareTitle,
                shareUrl,
                rightName: '分享'
            })
        })

        if (device.isWeixin) {
            const params = new URLSearchParams(window.location.search)
            const inviteCode = params.get('gatewayInviteCode') || ''
            // 初始化微信分享
            return import(/* webpackChunkName: "wxShare" */ './../compontents/share/wx-share.js').then(
                module => {
                    const wxShare = module.default
                    const {
                        shareContent,
                        shareIconUrl,
                        shareTitle,
                        shareUrl
                    } = titleData

                    wxShare.init({
                        title: shareTitle, // 分享标题
                        desc: shareContent, // 分享描述
                        link: urlObjectToStrings(shareUrl, {
                            gatewayInviteCode: inviteCode
                        }), // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                        imgUrl: shareIconUrl // 分享图标
                    })
                }
            )
        }
    }

    // 组件将要挂载的时候,获取模板数据
    async componentDidMount () {
        // await (device.isGomePlus && getParams().source === 'plus') && initializeEncryption()
        // await initializeEncryption() // 测试
        // 获取页面数据
        this.getList()
    }

    componentWillUnmount () {
        this.setTitle('银行精选', '#3364FF')
    }

    render () {
        let { list = [], titleData = {}, effectStatus = '2', productList = [], timeDiff, activityId, businessLine } = this.state
        // effectStatus：1 待生效, 2 生效中, 3 已失效
        // list为空时, 显示静态页面
        if (effectStatus === '2' && list.length === 0) {
            effectStatus = '1'
        }
        return (
            <React.Fragment>
                {effectStatus === '2' && (
                    <ConfigPage
                        list={list}
                        productList={productList}
                        activityId={activityId}
                        businessLine={businessLine}
                        titleData={titleData}
                        timeDiff={timeDiff} />
                )}
                {(effectStatus === '1' || effectStatus === '3') && (
                    <Expired effectStatus={effectStatus} titleData={titleData} />
                )}
            </React.Fragment>
        )
    }
}

export default App
